import { render, staticRenderFns } from "./coaching_goal.vue?vue&type=template&id=3290714b&"
import script from "./coaching_goal.vue?vue&type=script&lang=js&"
export * from "./coaching_goal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports